module.exports = __webpack_public_path__ + "static/img/4.94694fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4.png
// module id = 22
// module chunks = 0